import React, { Component, Fragment, useEffect, useRef, useState } from "react";
import useFetch from "../components/helpers/useFetch";


const SessionContext = React.createContext();
function SessionProvider({ children }) {
    const { isLoaded: sessionReady, data:sessionData } = useFetch('api/session/getSession');
    const [loading, setLoading] = useState(false);

    const [adminFilter, setAdminFilter] = useState(null);

    /**toast **/
    const [toastData, setToastData] = useState({ show: false, header: "", desc: "" });
    const toastError = (desc) => {
        setToastData({ show: true, header: "Napaka", desc: desc, error:true });
    };
    const toastOK = (desc) => {
        setToastData({ show: true, header: "Portal za stranke", desc: desc, error:false });
    };

   
    const [param, setParam] = useState(null);

    return (
        <SessionContext.Provider value={{ sessionReady, sessionData, loading, setLoading, toastOK, toastError, toastData, setAdminFilter, adminFilter }}>
            {children}
        </SessionContext.Provider>
    )
}

export { SessionProvider, SessionContext }